import { ContactAvatar, ContactBar, TContactType } from '@cian/contact-card-component';
import * as React from 'react';

import { DailyrentPartnerButtonContainer } from './AgentBookButtonContainer';
import * as styles from './AgentContainer.css';
//TODO: Это надо вернуть попапом в следующей итерации
// import { AgentProofsContainer } from './AgentProofsContainer';
import { AgentWorkHonestlyProofsContainer } from './AgentWorkHonestlyProofsContainer';
import { getQualityLevelSuperAgent, getQualityLevelSuperHost } from './AgentWorkHonestlyProofsContainer/utils';
import { BookedOfferDisclaimer } from './BookedOfferDisclaimer';
import { ContactActionsContainer } from './ContactActionsContainer/ContactActionsContainer';
import { SuperAgentLevelViewContainer } from './SuperAgentLevelViewContainer';
import { trackAgentCardLinkClick, trackDeveloperCardLinkClick } from './tracking';
import { BrandingLevelWrapper } from '../../../components/BrandingLevelWrapper';
import { useOfferContext } from '../../../context';
import { isRepresentative } from '../../../utils/computedProps/commercial/isRepresentative';
import { getAgentTypeTitle } from '../../../utils/getAgentTypeTitle';
import { RepresentativeBadgeContainer } from '../commercial/RepresentativeBadgeContainer';
import { useApplicationContext } from 'shared/utils/applicationContext';

const AVATAR_TYPE: {
  [key: string]: string | undefined;
} = {
  builderRepresentative: 'builder',
  consultant: 'builder',
  managementCompany: 'agency',
  realtor: 'agent',
  // У электронных торгов все отображения аватара как у типа "bank"
  tradingPlatform: 'bank',
  government: 'bank',
};

export function AgentContainer() {
  const { config } = useApplicationContext();
  const offerData = useOfferContext();
  const {
    agentType,
    agentImageLink,
    agentName,
    agentProfileLink,
    offer: { brandingLevel, dailyrent, isBookedFromDeveloper },
  } = offerData;
  const avatarType = (AVATAR_TYPE[agentType] || agentType) as TContactType;

  const isV2BookedFromDeveloperEnabled = config.get<boolean>('Newbuilding.BookedFromDeveloperDesktop.Enabled');
  const isBookedFromDeveloperAvaliable = Boolean(isBookedFromDeveloper && isV2BookedFromDeveloperEnabled);

  const showRepresentativeBadge = isRepresentative(offerData.offer);
  const showQualityBadge = Boolean(getQualityLevelSuperAgent(offerData) || getQualityLevelSuperHost(offerData));
  const hasBadgesRow = showRepresentativeBadge || showQualityBadge;

  const onNameClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.stopPropagation();

      switch (agentType) {
        case 'builder':
          trackDeveloperCardLinkClick(offerData.offer);
          break;
        case 'realtor':
        case 'agency':
          trackAgentCardLinkClick();
          break;
        default:
          break;
      }

      window.open(agentProfileLink, '_blank', 'noopener,noreferrer');
    },
    [agentType, agentProfileLink],
  );

  if (dailyrent?.hotelData?.isHotel) {
    return (
      <div data-name="DailyrentActionButtonsContainer" className={styles['hotel-button']}>
        <DailyrentPartnerButtonContainer />
      </div>
    );
  }

  return (
    <BrandingLevelWrapper brandingLevel={brandingLevel}>
      <ContactBar
        title={getAgentTypeTitle(agentType)}
        avatar={<ContactAvatar type={avatarType} src={agentImageLink} />}
        name={agentName || ''}
        href={agentProfileLink}
        target="_blank"
        labels={
          <>
            <AgentWorkHonestlyProofsContainer />
            {hasBadgesRow && (
              <div className={styles['badges-row']}>
                <RepresentativeBadgeContainer />
                <SuperAgentLevelViewContainer />
              </div>
            )}
          </>
        }
        actions={
          <>
            {isBookedFromDeveloperAvaliable && <BookedOfferDisclaimer />}
            <ContactActionsContainer />
          </>
        }
        onNameClick={onNameClick}
      />
    </BrandingLevelWrapper>
  );
}
